module.exports = __webpack_public_path__ + "img/info_btn.e7c60923.png";